<geaui-page-header pageTitle="Unit Converter" [hasBackArrow]="false" [withSidebar]="true">
</geaui-page-header>

<div class="Content">

  <div *ngFor="let contextOption of unitContextOptions">
    <span class="InputBlock">
      <span class="Label">{{ MeasurementContextDescriptions.get(contextOption.context) }}</span>
      <measurement-text-box class="Value" [(Value)]="contextOption.usValue" [Context]="contextOption.context" 
        [IsUsUnits]="true" [UsDecimalPlaces]="3" [SiDecimalPlaces]="3"
        (ValueChange)="usValueChanged(contextOption)"></measurement-text-box>
      <span class="Unit">{{ getUnitText(contextOption.context, true) }}</span>
      <span>=</span>
      <measurement-text-box class="Value" [(Value)]="contextOption.siValue" [Context]="contextOption.context" 
        [IsUsUnits]="false" [UsDecimalPlaces]="3" [SiDecimalPlaces]="3"
        (ValueChange)="siValueChanged(contextOption)"></measurement-text-box>
      <span class="Unit">{{ getUnitText(contextOption.context, false) }}</span>
    </span>
    <br>
  </div>

</div>